export default function LogOutIcon({
    style
}) {
    return <svg style={style} width="26" height="27" viewBox="0 0 26 27" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.7647 26H3.45098C2.80094 26 2.17752 25.7073 1.71788 25.1864C1.25823 24.6655 1 23.9589 1 23.2222V3.77778C1 3.04107 1.25823 2.33453 1.71788 1.81359C2.17752 1.29266 2.80094 1 3.45098 1H12.7647" stroke="#536987" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M18.1855 13.5566H7" stroke="#536987" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M15.1855 21.4493L24.7262 13.2247L15.1855 5" fill="#83CFA4"/>
    <path d="M15.1855 21.4493L24.7262 13.2247L15.1855 5V21.4493Z" stroke="#536987" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
}